import React from 'react'
import PropTypes from 'prop-types'

const LETTERS = {
  F: '51.9,29.2 0,29.2 0,111.5 15.4,111.5 15.4,77.9 46.2,77.9 46.2,65.7 15.4,65.7 15.4,41.4 51.9,41.4,51.9,29.2',
  A: 'M94.3,58.3L116.6,97H71.9L94.3,58.3 M94.3,29.4l-47.4,82.1h94.7L94.3,29.4L94.3,29.4z',
  R1: 'M176.5,29.2h-25.1v82.3h15.3V79.3h6.5c1.5,0,2.7,0.2,3.4,0.6c0.8,0.4,1.5,1.1,2.1,2.1l17.3,26.3c1.2,2,3.1,3.1,5.7,3.1h13.8L195,81.1c-0.7-1.1-1.4-2-2.3-2.8s-1.7-1.5-2.7-2c2.9-0.9,5.5-2.1,7.7-3.6c2.3-1.5,4.2-3.3,5.7-5.3c1.5-2,2.7-4.2,3.5-6.7c0.8-2.5,1.2-5.1,1.2-7.9c0-3.5-0.6-6.7-1.8-9.6c-1.2-2.9-3.1-5.4-5.7-7.5c-2.6-2.1-5.8-3.7-9.8-4.9C186.9,29.8,182.1,29.2,176.5,29.2L176.5,29.2z M166.7,68.3V41h9.8c5.7,0,9.9,1.1,12.6,3.4c2.7,2.2,4.1,5.4,4.1,9.6c0,2.1-0.3,4-1,5.7c-0.7,1.7-1.7,3.3-3.1,4.5c-1.4,1.3-3.1,2.3-5.3,3c-2.1,0.7-4.7,1.1-7.5,1.1H166.7L166.7,68.3z',
  R2: 'M249.7,29.2h-25.1v82.3h15.3V79.3h6.5c1.5,0,2.7,0.2,3.4,0.6c0.8,0.4,1.5,1.1,2.1,2.1l17.3,26.3c1.2,2,3.1,3.1,5.7,3.1h13.8l-20.6-30.4c-0.7-1.1-1.4-2-2.3-2.8s-1.7-1.5-2.7-2c2.9-0.9,5.5-2.1,7.7-3.6c2.3-1.5,4.2-3.3,5.7-5.3c1.5-2,2.7-4.2,3.5-6.7c0.8-2.5,1.2-5.1,1.2-7.9c0-3.5-0.6-6.7-1.8-9.6c-1.2-2.9-3.1-5.4-5.7-7.5c-2.6-2.1-5.8-3.7-9.8-4.9C260,29.8,255.2,29.2,249.7,29.2L249.7,29.2z M239.9,68.3V41h9.8c5.7,0,9.9,1.1,12.6,3.4c2.7,2.2,4.1,5.4,4.1,9.6c0,2.1-0.3,4-1,5.7c-0.7,1.7-1.7,3.3-3.1,4.5s-3.1,2.3-5.3,3c-2.1,0.7-4.7,1.1-7.5,1.1H239.9L239.9,68.3z',
  O: 'M333.9,42.6c15.3,0,27.8,12.5,27.8,27.8s-12.5,27.8-27.8,27.8c-15.3,0-27.8-12.5-27.8-27.8S318.5,42.6,333.9,42.6 M333.9,28.2c-23.3,0-42.2,18.9-42.2,42.2c0,23.3,18.9,42.2,42.2,42.2s42.2-18.9,42.2-42.2C376.1,47.1,357.2,28.2,333.9,28.2L333.9,28.2z',
  W: 'M496.6,29.2h-12c-1.3,0-2.4,0.3-3.3,1c-0.9,0.7-1.5,1.5-1.7,2.4l-14,49.2c-0.6,2.4-1.2,5.1-1.7,8.1c-0.6-3.1-1.4-5.8-2.2-8.1l-16.1-49.2c-0.4-1-1-1.9-1.9-2.5c-0.8-0.6-1.9-1-3.2-1H436c-1.3,0-2.4,0.4-3.3,1.1c-0.9,0.7-1.5,1.5-1.8,2.4l-16.2,49.2c-0.4,1.2-0.8,2.5-1.2,3.9c-0.4,1.4-0.7,2.9-1,4.5c-0.3-1.6-0.6-3-0.9-4.5c-0.3-1.4-0.6-2.7-0.9-4l-14-49.2c-0.3-1.1-0.9-1.9-1.8-2.5c-0.9-0.6-2-0.9-3.3-0.9h-12.8l25.5,82.3h13.9l18.1-56.2c0.3-0.7,0.5-1.5,0.7-2.3c0.2-0.8,0.5-1.7,0.7-2.7c0.4,2,0.9,3.6,1.4,5l18,56.2H471L496.6,29.2L496.6,29.2z',
  line: ''
}

export default class Logo extends React.Component {

  render () {
    const svg = (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 497 139'>
      <polygon points={LETTERS.F} />
      <path d={LETTERS.A} />
      <path d={LETTERS.R1} />
      <path d={LETTERS.R2} />
      <path d={LETTERS.O} />
      <path d={LETTERS.W} />
      <rect
        x='302.3'
        y='124.1'
        width='63'
        height='14.4' />
    </svg>
    )
    return (
      <div {...this.props}>
        {svg}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/logo.js